<template>
    <div class="homepage__testimonials">
        <div class="homepage__testimonials__slider">
            <OldCarousel :breakpoints="breakpoints" :settings="settings">
                <Slide v-for="(tweet, index) in tweets" :key="index">
                    <div class="testimonial">
                        <div class="testimonial__info">
                            <a
                                target="_blank"
                                rel="noopener"
                                :href="tweet.profileLink"
                            >
                                <img :src="tweet.image" :alt="tweet.name" />
                            </a>
                            <div class="name">
                                <h3>{{ tweet.name }}</h3>
                                <p>{{ $t(tweet.title) }}</p>
                            </div>
                        </div>
                        <div class="testimonial__content">
                            <p v-html="$t(tweet.content)" />
                        </div>
                    </div>
                </Slide>
                <template #addons>
                    <Navigation />
                </template>
            </OldCarousel>
        </div>
    </div>
</template>

<script>
import { Carousel as OldCarousel, Slide, Navigation } from 'vue3-carousel';

export default {
    components: {
        OldCarousel,
        Slide,
        Navigation,
    },
    data() {
        return {
            activeSlide: 1,
            tweets: [
                {
                    content: 'lp.testimonials.zeeAnn',
                    name: 'Zee Ann Poerio',
                    image: '/images/lp/testimonial_zee_ann_poerio.svg',
                    title: 'lp.testimonials.k8Teacher',
                    profileLink: 'https://twitter.com/magistrazee',
                },
                {
                    content: 'lp.testimonials.amyNoyes',
                    name: 'Amy Noyes',
                    image: '/images/lp/testimonial_amy_noyes.svg',
                    title: 'lp.testimonials.k8Teacher',
                    profileLink: 'https://twitter.com/edtechgypsy',
                },
                {
                    content: 'lp.testimonials.jenniferWilliams',
                    name: 'Jennifer Williams',
                    image: '/images/lp/testimonial_jennifer_williams.svg',
                    title: 'lp.testimonials.2ndGradeTeacher',
                    profileLink: 'https://twitter.com/jlwilliams2015',
                },
                {
                    content: 'lp.testimonials.micheleHerrman',
                    name: 'Michele Herrmann',
                    image: '/images/lp/testimonial_micherele_herrmann.svg',
                    title: 'lp.testimonials.k8Teacher',
                    profileLink: 'https://twitter.com/herrmannmichele',
                },
                {
                    content: 'lp.testimonials.jenHarding',
                    name: 'Jen Harding',
                    image: '/images/lp/testimonial_jen_harding.svg',
                    title: 'lp.testimonials.3rdGradeTeacher',
                    profileLink: 'https://twitter.com/Mrs3rdHarding',
                },
                {
                    content: 'lp.testimonials.whiteSulphurElem',
                    name: 'White Sulphur Elem',
                    image: '/images/lp/testimonial_white_suphur_elem.svg',
                    title: 'lp.testimonials.whiteSulphur',
                    profileLink: 'https://twitter.com/whitesulphures',
                },
            ],
            settings: {
                itemsToShow: 1,
                snapAlign: 'center',
            },
            breakpoints: {
                800: {
                    itemsToShow: 2,
                },
                1000: {
                    itemsToShow: 3,
                },
            },
        };
    },
};
</script>

<style scoped lang="scss">
.homepage__testimonials {
    background-color: #ffc75a;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 0 0;

    @include mq($w-min-desktop, min) {
        flex-direction: row;
        align-items: flex-start;
        padding: 4rem 0 4rem;
    }

    &::before {
        content: '';
        display: block;
        width: 100%;
        background-color: #ffc75a;
        position: absolute;
        left: 0;
        z-index: 1;
        transform: skewY(-4deg);
        top: -35px;
        height: 100px;

        @include mq($w-min-desktop, min) {
            transform: skewY(-2deg);
        }

        @include mq($w-min-wide-desktop, min) {
            height: 125px;
        }
    }

    &__slider {
        max-width: 79%;
        z-index: 6;
    }

    .testimonial {
        background: #fff;
        border-radius: 10px;
        color: #000;
        margin: 1.7rem 0.5rem 1.5rem;
        padding: 0.5rem;
        border-top: 12px solid #f0f0f0;
        position: relative;
        width: calc(100% - 2rem);

        @include mq($w-max-sm, max) {
            margin: 1.7rem 0.25rem 1.5rem;
        }

        &:after {
            content: '';
            position: absolute;
            top: -40px;
            left: 25%;
            margin-left: -25px;
            width: 0;
            height: 0;
            border-bottom: 40px solid #fff;
            border-left: 25px solid transparent;
            border-right: 25px solid transparent;

            @include mq($w-min-desktop, min) {
                border-top-width: 40px;
                border-left-width: 40px;
                border-right-width: 40px;
                margin-left: -40px;
            }
        }

        &__info {
            display: flex;

            a {
                margin-right: 1rem;
            }

            .name {
                display: flex;
                flex-direction: column;
                justify-content: center;

                h3 {
                    color: #333333;
                    font-size: 1rem;
                    line-height: 1.5rem;
                }

                p {
                    margin: 0.5rem 0 0;
                }
            }
        }

        &__content {
            margin-top: 1rem;

            @include mq($w-min-desktop, min) {
                margin-top: 0;
            }

            p {
                line-height: 1.375rem;
                margin: 0;
                padding-bottom: 1rem;
                padding-right: 1rem;

                @include mq($w-min-desktop, min) {
                    margin-left: 6rem;
                }
            }
        }
    }
}
</style>
<style>
.testimonial span {
    color: #a179e4;
}
</style>
